import $axios from '../services/apiLms.js'

const state = () => ({
    tatibs: [],
    tatib_detail: {},
    tatib_types: [],
    tatib_chapters: [],
    tatib_clauses: [],
    tatib_form_data: {},
})

const mutations = {
    ASSIGN_TATIB(state, payload) {
        state.tatibs = payload
    },
    ASSIGN_TATIB_DETAIL(state, payload) {
        state.tatib_detail = payload
    },
    ASSIGN_TATIB_TYPES(state, payload) {
        state.tatib_types = payload
    },
    ASSIGN_TATIB_CHAPTERS(state, payload) {
        state.tatib_chapters = payload
    },
    ASSIGN_TATIB_CLAUSES(state, payload) {
        state.tatib_clauses = payload
    },
    ASSIGN_TATIB_DATA_FORM(state, payload) {
        state.tatib_form_data = payload
    },
    CLEAR_TATIB_DATA(state) {
        state.tatibs = [];
    }
}

const actions = {
    clearTatibData({commit}) {
        commit('CLEAR_TATIB_DATA');
    },
    getTatibs({ commit }, paramsData) {
        return new Promise((resolve) => {
            $axios.get(`operator/tatib/data`, { params : paramsData })
                .then((response) => {
                    commit('ASSIGN_TATIB', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getTatibDetail({ commit }, id) {
        return new Promise((resolve) => {
            $axios.get(`operator/tatib/data/${id}`)
                .then((response) => {
                    commit('ASSIGN_TATIB_DETAIL', response.data.data)
                    resolve(response.data.data)
                })
        })
    },
    getTatibTypes({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`operator/tatib/type`)
                .then((response) => {
                    commit('ASSIGN_TATIB_TYPES', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getTatibChapters({ commit }, type_id) {
        return new Promise((resolve) => {
            $axios.get(`operator/tatib/chapter?type_id=${type_id}`)
                .then((response) => {
                    commit('ASSIGN_TATIB_CHAPTERS', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getTatibClauses({ commit }, chapter_id) {
        return new Promise((resolve) => {
            $axios.get(`operator/tatib/clause?chapter_id=${chapter_id}`)
                .then((response) => {
                    commit('ASSIGN_TATIB_CLAUSES', response.data.data)
                    resolve(response.data)
                })
        })
    },
    storeTatibData({ commit }, payload) {
        return new Promise((resolve, reject) => {
           $axios.post(`operator/tatib/data`, payload)
                .then((response) => {
                    commit('ASSIGN_TATIB_DATA_FORM', payload)
                    commit('SET_SUCCESS', response.data.message, { root: true })
                    resolve(response.data.data)
                })
                .catch(err => {
                    commit('SET_ERRORS', err.response.data, { root: true })
                    reject(err.response.data)
                })
        })
    },
    updateTatipData({ commit }, payload) {
        return new Promise((resolve, reject) => {
           $axios.put(`operator/tatib/data/${payload.id}`, payload)
                .then((response) => {
                    commit('ASSIGN_TATIB_DATA_FORM', payload)
                    commit('SET_SUCCESS', response.data.message, { root: true })
                    resolve(response.data.data)
                })
                .catch(err => {
                    commit('SET_ERRORS', err.response.data, { root: true })
                    reject(err.response.data)
                })
        })
    },
    deleteTatibData({commit}, id) {
        return new Promise((resolve, reject) => {
            $axios.delete(`operator/tatib/data/${id}`).then(response => {
                resolve(response);
            }).catch(response => {
                reject(response);
            });
        });
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}